import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(
  (theme) => ({
    alignText: {
      justifyContent: "flex-start",
      paddingLeft: 0,
    },
    emailButton: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      justifyContent: "flex-start",
      paddingLeft: 0,
    },
  }),
  { index: 10 }
);
